import Review from "./review";
export default Review;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/review/index.ts
// module id = CUEi
// module chunks = 2